<template>
    <div>
        <DetailFrame>
            <template>
                <div class="expertTeacherDetail">
                    <div class="info-row myflex-v">
                        <div class="head-img bg-cover border-gray mr15" 
                            :style="'background:url('+art.addOssResize(userInfo.photoPath ? userInfo.photoPath : art.defaultHeadPhoto,100)+') no-repeat center;'">
                        </div>
                        <div>
                            <div class="mb3">
                                <span class="fon16 fweight mr15">{{userInfo.userName | checkPhone}}</span>
                                <span v-show="userInfo.identityLabelName" class="label">{{userInfo.identityLabelName}}</span>
                            </div>
                            <div v-show="userInfo.majorName">专业：{{userInfo.majorName}}</div>
                        </div>
                    </div>

                    <div class="mb20">
                        <div class="title"><span class="titleFont">教学风采</span></div>
                        <div class="fengcai-box">
                            <div v-if="fengcaiList.length>0">
                                <div class="fengcai-list" v-for="(fengItem,fengIndex) in fengcaiList" :key="fengIndex"
                                    @click="preSource(fengItem.url,fengItem.type)">
                                    <el-image
                                        :src="fengItem.showImg" fit="cover" lazy class="fengcai-cover" >
                                    </el-image>
                                    <div class="video-mask myflex-lv" v-if="fengItem.extension=='mp4'">
                                        <span class="el-icon-video-play video-icon"></span>
                                    </div>
                                </div>
                                <el-pagination
                                    :pager-count="5"
                                    @current-change="fengCurrentChange"
                                    :current-page.sync="fengCurrentPage"
                                    :page-size="fengPageSize"
                                    layout="total, prev, pager, next"
                                    :total="fengTotal">
                                </el-pagination>
                            </div>
                            <div v-else class="nodata">暂无数据~</div>
                        </div>
                    </div>

                    <div class="mb20 myhide">
                        <div class="title"><span class="titleFont">社区大讲堂课程</span></div>
                        <div>
                            <div v-if="courseList.length>0">
                                <el-row :gutter="15" class="courseListBox">
                                    <el-col :span="6" v-for="(item3,index3) in courseList" :key="index3" >
                                        <CourseListItem 
                                            :courseid="item3.courseId"
                                            :studioid="item3.studioId"
                                            :cover="item3.courseCover" 
                                            :name="item3.courseName" 
                                            :label="item3.courseLabelNames" 
                                            :majorname="item3.majorName" 
                                            :teacher="item3.ownerName" 
                                            :type="item3.courseType"
                                        />
                                    </el-col>
                                </el-row>
                                 <el-pagination
                                    :pager-count="5"
                                    @current-change="courseCurrentChange"
                                    :current-page.sync="courseCurrentPage"
                                    :page-size="coursePageSize"
                                    layout="total, prev, pager, next"
                                    :total="courseTotal">
                                </el-pagination>
                            </div>
                            <div v-else class="nodata">暂无数据~</div>
                        </div>
                    </div>
                    
                    <div class="mb20">
                        <div class="title"><span class="titleFont">教学成绩</span></div>
                        <div v-if="joinItemList && joinItemList.length>0">
                            <div class="myflex-v">
                                <b class="fweight mr10">选择其学生参加的测评项目:</b>
                                <el-select v-model="joinExamItem" placeholder="选择项目" @change="selectEval">
                                    <el-option v-for="(joinItem,joinIndex) in joinItemList" :key="joinIndex" :label="joinItem.name" :value="joinItem.id"></el-option> 
                                </el-select>                        
                            </div>
                            <div class="mt20 myflex-v flexWrap">
                                <div class="teaScoreChart flex1" id="my-chart" v-show="chartIsShow"></div>
                                <div class="teaScoreTotal myflex-lv border-gray">
                                    <div class="ml20 mr20">
                                        <h3 class="font18 fweight mb15">{{passList.totalCount}}</h3>
                                        <div>考生人数</div>
                                    </div>
                                    <div class="ml20 mr20">
                                        <h3 class="font18 fweight mb15">{{passList.passCount}}</h3>
                                        <div>通过人数</div>
                                    </div>
                                    <div class="ml20 mr20">
                                        <h3 class="font18 fweight mb15">{{art.multiply(passList.passRatio,100)}}%</h3>
                                        <div>通过率</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="nodata">暂无数据~</div>
                        
                    </div>

                    <div class="mb20">
                        <div class="title"><span class="titleFont">素养提升之路</span></div>
                        <div class="zheng-box">
                            <div v-if="zhengList.length>0">
                                <div class="myflex flexWrap certBoxItemBox">
                                    <div class="certBoxItem" v-for="(item, index) in zhengList" :key="index" >
                                        <div class="certImg myflex flexDirection-col" style="background:url() center no-repeat" @click="preCert(item.certificate, item)">
                                            <img class="certTopImg" src="@/assets/img/center/certTop.png" alt=""/>
                                            <div class="certName myflex-lv flex1"><div class="ellipsis2">{{ item.certificateName }}</div></div>
                                            <div v-if="item.certificateStatus == 1" class="shIng myflex-lv">
                                                <img src="@/assets/img/sh.png" class="shIngImg" alt="" />
                                            </div>
                                        </div>
                                        <div class="botTitle mt10 text-center"><div class="ellipsis2">{{ item.certificateName }}</div></div>
                                    </div>
                                </div>
                                <div class="elPageBox" v-show="total_zs>0">
                                    <el-pagination
                                        background
                                        :pager-count="5"
                                        @current-change="currentChange_zs"
                                        :current-page.sync="pageNum_zs"
                                        :page-size="pageSize_zs"
                                        layout="prev, pager, next"
                                        :total="total_zs">
                                    </el-pagination>
                                </div>
                            </div>
                            <div v-else class="nodata">暂无数据~</div>
                        </div>
                    </div>
                </div>
            </template>
        </DetailFrame>
    </div>
</template>

<style lang="scss" scoped>
    .expertTeacherDetail{padding:15px;}
    .info-row{padding-bottom:15px;border-bottom:1px dashed #ddd;margin-bottom:15px;}
    .head-img{width:52px;height:52px;background-color:#ebebeb !important;border-radius:50%;background-size:cover !important;}
    .title{position:relative;margin-bottom:20px;}
    .titleFont{background:$theme-color;font-size:14px;color:#fff;border-radius:4px;padding:4px 10px;display:inline-block;}
    .title:after{content:'';position:absolute;bottom:0;left:0;height:2px;background:$theme-color;width:100%;}
    .fengcai-list{width:210px;height:132px;margin:0 15px 15px 0;position:relative;display:inline-block;border:1px solid #eee;}
    .teaScoreChart{height:300px;margin-right:20px;margin-bottom:20px;}
    .teaScoreTotal{padding:20px;height:147px;width:400px;text-align:center;}
    .border-gray{border:1px solid #ddd;}
    .fengcai-cover{width:100%;height:100%;}
    .video-mask{position:absolute;top:0;height:100%;width:100%;left:0;z-index:10;background:rgba(0,0,0,.3)}
    .video-icon{color:#fff;font-size:40px;z-index:11;}
    .label{color: #4E2F13;
        background-image: -webkit-gradient(linear, left bottom, left top, from(#FDEC96), to(#FFD872));
        background-image: linear-gradient(0deg, #FDEC96, #FFD872);
        padding: 4px 10px;
        display: inline-block;
        border-radius: 30px;}


    .certBoxItemBox{margin:0 -12.5px;}
    .certBoxItem {width:169px;margin: 0 12.5px 20px 12.5px;}
    .certImg {height:200px;background-size: cover !important;
        border-radius: 4px;position: relative;border: 3px solid #E3F4FF;}
    .certTopImg{width:100%;}
    .shIng {position: absolute;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.3);}
    .shIngImg {height: 60px;}
    .certName {line-height: 1.4;text-align: center;color:#0D88D3;font-weight:600;padding:5px 8px;}
</style>

<script>
import DetailFrame from "@/components/DetailFrame.vue";
import CourseListItem from '@/components/CourseListItem.vue';
import * as echarts from 'echarts';
export default {
    name: "expertTeacherDetail",
    components: {
        DetailFrame,
        CourseListItem,
    },
    data(){
        return {
            art: art,
            id: art.getUrlData('id'),
            userInfo: {},
            //个人风采
            fengcaiList: [],
            fengCurrentPage: 1,
            fengPageSize: 10,
            fengTotal: 0,
            //证书
            zhengList: [],
            pageNum_zs: 1,
            pageSize_zs: 12,
            total_zs: 0,
            //课程
            courseList:[],
            courseTotal: 0,
            courseCurrentPage: 1,
            coursePageSize: 8,
            //教学成绩
            //参加的测评项目
            joinItemList: [],
            joinExamItem: '',
            passList: {
                passCount:'',
                passRatio:'',
                totalCount:'',
            },
            chartList: [],
            chartIsShow: true,
        }
    },
    computed:{
        zhengImgList(){
            let arr = [];
            let d = this.zhengList;
            for( var i=0; i<d.length; i++){
                arr.push(art.addOssurlHeader(d[i].certificate));
            }
            return arr;
        },
    },
    methods:{
        //查询教师详情
        getTeacherInfoByUserId(){
            var data = {
                userId: this.id,
            }
            this.$api.web.getTeacherInfoByUserId(data).then(res=>{
                this.userInfo = res.body.teacherInfo;
            }).catch(res=>{})
        },

        //风采列表
        getFengcaiList(page){
            let vm = this;
            var pageNum = page ? page : this.fengCurrentPage;
            var data = {
                teacherId: this.id,
                pageNum: pageNum,
                pageSize: this.fengPageSize,
            }
            this.$api.web.websitContentSelectTeacherShineListByTeacherId(data).then(res=>{
                let arr = res.body.dataList;
                for (var i in arr){
                    arr[i].url = vm.$utils.addOssurlHeader(arr[i].catalog + '/'+ arr[i].filename +'.'+arr[i].extension);
                    arr[i].type = vm.$utils.checkSourceUrlType('.'+arr[i].extension);
                    if( arr[i].minetype == '图片' ){
                        arr[i].showImg = vm.$utils.addOssResize(arr[i].url, 300);
                    }
                    else{
                        arr[i].showImg = arr[i].thumb ? vm.$utils.addOssResize(arr[i].thumb, 300) : require('@/assets/img/defaultCover.png');
                    }
                }
                this.fengcaiList = arr;
                this.fengTotal = res.body.total;
                this.fengCurrentPage = pageNum;
            }).catch(res=>{})
        },

        //风采页面改变
        fengCurrentChange(page){
            this.getFengcaiList(page);
        },
        
        //获取证书列表
        getZhengList(num) {
            var vm = this;
            var pageNum = num ? num : vm.pageNum_zs;
            var data = { 
                userId: this.id,
                pageNum:pageNum,
                pageSize: vm.pageSize_zs,
            }
            this.$api.web.getUserCertificateListByUserId(data).then(res => {
                vm.pageNum_zs = pageNum;
                vm.total_zs = res.body.total;
                var d = res.body.userCertificates;
                if (res.success && d && d.length) {
                var arr = d ? d : [];
                for (var i in arr) {
                    arr[i].showImg = arr[i].certificate ? art.addOssResize(arr[i].certificate, 160) : require('@/assets/img/certDefaultImg.png');
                }
                vm.zhengList = arr;
                } else {
                vm.zhengList = [];
                }
            })
        },

        currentChange_zs(num){
            this.getZhengList(num);
        },

        preCert(img, obj) {
            var vm = this;
            if(img){
                //vm.preImg(art.addOssurlHeader(img));
                vm.preSource(vm.$utils.addOssurlHeader(img),'image')
            }else{
                var data = { token: vm.userInfo.token, source: obj.source, sourceId: obj.sourceId }
                this.$api.mainApi.getUserCertificateDetail(data).then(res => {
                    console.log(res);
                    //vm.preImg(art.addOssurlHeader(res.body.userCertificate.certificate));
                    vm.preSource(vm.$utils.addOssurlHeader(res.body.userCertificate.certificate),'image')
                })
            }
        },

        //获取老师的大讲堂课程
        getShequCourse(page){
            var pageNum = page ? page : this.courseCurrentPage;
            var data = {
                userId: this.id,
                pageNum: pageNum,
                pageSize: this.coursePageSize,
            }
            this.$api.web.websitContentSelectCommunityCourseListByUserId(data).then(res=>{
                this.courseList = res.body.dataList;
                this.courseTotal = res.body.total;
                this.courseCurrentPage = pageNum;
            }).catch(res=>{})
        },

        //课程页面切换
        courseCurrentChange(page){
            this.getShequCourse(page);
        },

        //获取测评列表
        getJoinList(){
            this.$api.web.websitContentSelectEvaluationListByTeacherId({teacherId:this.id}).then(res=>{
                this.joinItemList = res.body.dataList;
                if( this.joinItemList.length>0 ){
                    console.log(this.joinItemList[0].id);
                    this.joinExamItem = this.joinItemList[0].id;
                    
                    this.getTeaScoreChartData();
                }
            }).catch(res=>{})
        },

        //老师成绩统计
        getTeaScoreChartData(){
            var data = {
                evaluationId: this.joinExamItem,
            }
            this.$api.web.websitContentCountEvaluationOrderLevel(data).then(res=>{
                let chartList = res.body.dataList;
                //this.chartList = chartList;
                this.passList = res.body.passList[0];
                if(chartList &&chartList.length){
                    
                    this.chartIsShow = true;
                    this.loadChart(chartList);
                }else{
                    this.chartIsShow = false;
                }
            }).catch(res=>{})
        },

        //loadData
        loadChart(list){
            var nameData = [];
            var data = [];
            for( var i=0; i<list.length; i++ ){
                nameData.push(list[i].levelName);
                var ratio = art.toFixed((list[i].levelCount/this.passList.totalCount)*100,2);
                data.push({
                    name: list[i].levelName+'：'+list[i].levelCount+'人，占比'+ratio+'%',
                    value: list[i].levelCount,
                });
            }
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    show: false,
                    left: 10,
                    data: nameData,
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['35%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: true,
                                position: 'outside'
                            },
                            emphasis: {
                                show: false,
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true
                            }
                        },
                        data: data
                    }
                ]
            };
            var dom = document.getElementById("my-chart");
            var myChart = echarts.init(dom);
            myChart.setOption(option, true);
        },

        preSource(url,type){
            this.$preSource(url,type);
            art.delayRollAuto();
        },

        //选择测评
        selectEval(id){
           this.joinExamItem = id;
           this.getTeaScoreChartData();
        }
    },
    created(){
        this.getTeacherInfoByUserId();
        setTimeout(res=>{
            this.getFengcaiList();
            this.getZhengList();
            //this.getShequCourse();
        },10)
        
    },
    mounted(){
        this.getJoinList();
    },
    filters:{
        //如果是手机号，中间打*
        checkPhone(str){
            if( (/^1[2|3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(str)) ){ 
                var a = str.substr(0,3);
                var b = str.substr(-5,4);
                return a +'****'+ b;
            }else{
                return str;
            }
        },
    }
};
</script>
